const e = Object.freeze({
  "1/2": 0.5,
  "1/3": 0.3333333333333333,
  "2/3": 0.6666666666666666,
  "1/4": 0.25,
  "3/4": 0.75,
  "1/5": 0.2,
  "2/5": 0.4,
  "3/5": 0.6,
  "4/5": 0.8,
  "1/10": 0.1,
  "2/10": 0.2,
  "3/10": 0.3,
  "4/10": 0.4,
  "5/10": 0.5,
  "6/10": 0.6,
  "7/10": 0.7,
  "8/10": 0.8,
  "9/10": 0.9,
  "1/24": 0.041666666666666664,
  "2/24": 0.08333333333333333,
  "3/24": 0.125,
  "4/24": 0.16666666666666666,
  "5/24": 0.20833333333333334,
  "6/24": 0.25,
  "7/24": 0.2916666666666667,
  "8/24": 0.3333333333333333,
  "9/24": 0.375,
  "10/24": 0.4166666666666667,
  "11/24": 0.4583333333333333,
  "12/24": 0.5,
  "13/24": 0.5416666666666666,
  "14/24": 0.5833333333333334,
  "15/24": 0.625,
  "16/24": 0.6666666666666666,
  "17/24": 0.7083333333333334,
  "18/24": 0.75,
  "19/24": 0.7916666666666666,
  "20/24": 0.8333333333333334,
  "21/24": 0.875,
  "22/24": 0.9166666666666666,
  "23/24": 0.9583333333333334
});
export {
  e as widths
};
